import { render, staticRenderFns } from "./TabAvailabilityAddButton.vue?vue&type=template&id=840fca3e"
import script from "./TabAvailabilityAddButton.vue?vue&type=script&lang=js"
export * from "./TabAvailabilityAddButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports